import { noop } from 'lodash-es';

export default noop;
